import React from 'react'
import Card from './Card'

{
  /* <ScholarshipCard
    name="Full Sail University"
    logo="images/fullsail.jpg"
    link="https://www.fullsail.edu/about/esports" /> */
}

const ScholarshipCard = ({ name, logo, link = 'https://playvs.com' }) => {
  return (
    <Card key={name} className="column--fourth contained centered">
      <div className="meta centered">
        {/*<img src={logo} />*/}
        <div className="img" style={{ backgroundImage: `url(${logo})` }} />
        <div className="h7">{name}</div>
        <a href={link} rel="nofollow" target="_blank">
          Learn more
        </a>
      </div>
    </Card>
  )
}

export default ScholarshipCard



// WEBPACK FOOTER //
// ./src/common/ui/good_components/ScholarshipCard.jsx